
const _ = require('lodash');
const $ = require('jquery');
const ko = require('knockout');

const rangeSlider = require('rgs-rangeslider-pure');


ko.bindingHandlers.rangeSliderPure = {
	init: function (element, valueAccessor, allBindings) {
		const $element = $(element);

		rangeSlider.create(element, _.defaults({
			onSlideEnd: function (val) {
				$element.trigger('slideend.rangeslider', val);
			},
			onSlide: function (val) {
				$element.trigger('slide.rangeslider', val);
			},
			onSlideStart: function () {
				$element.trigger('slideStart.rangeslider', $element);
			}
		}, ko.unwrap(valueAccessor())));

		ko.computed(function () {
			element.rangeSlider.update(ko.unwrap(valueAccessor()), true);
		}, null, {
			disposeWhenNodeIsRemoved: element,
		});

		if (allBindings.has('value')) {
			const updateValueFromDom = function updateValueFromDom (value) {
				const observable = allBindings.get('value');
				if (ko.isWritableObservable(observable)) {
					observable(value);
				}
			};

			const events = [ 'slideend.rangeslider' ];

			if (allBindings.has('valueUpdate')) {
				const extraEvents = [].concat(allBindings.get('valueUpdate'));
				events.splice(events.length, 0, ...extraEvents);
			}

			_.each(events, (eventName) => {
				$element.on(eventName, (e, val) => {
					updateValueFromDom(val);
				});
			});

			const updateValueFromModel = function updateValueFromModel (value) {
				element.rangeSlider.update({ value }, false);
			};

			ko.computed(function () {
				updateValueFromModel(ko.unwrap(allBindings.get('value')));
			}, null, {
				disposeWhenNodeIsRemoved: element,
			});

			ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
				element.rangeSlider.destroy();
			});
		}
	},
};

